/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_WarmInputs */

const en_ui_track_intensity_warm = /** @type {(inputs: Ui_Track_Intensity_WarmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm`)
};

const de_ui_track_intensity_warm = /** @type {(inputs: Ui_Track_Intensity_WarmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm`)
};

/**
* | output |
* | --- |
* | "Warm" |
*
* @param {Ui_Track_Intensity_WarmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_warm = /** @type {((inputs?: Ui_Track_Intensity_WarmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_WarmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_warm(inputs)
	return de_ui_track_intensity_warm(inputs)
});